import { Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IProduct, products } from '../products';
import Filter from './Filter';
import Header from './Header';
import { categories, Category, Sorter, sorters } from '../types';
import { Product } from './Product';
import './Products.scss'
import SendGiftModal from './SendGiftModal';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
export default function Products() {
    const params = useLocation().search;
    const categoryParam = new URLSearchParams(params).get('c');
    const categroyId: number = +(categoryParam ? categoryParam : "-1");
    const category: Category | undefined = categories.find(c => c.id === categroyId)
    const categoryName: string = category ? category.name : ""
    
    const [selectedProduct, setSelectedProduct] = useState<IProduct>()
    const [modalOpen, setModalOpen] = useState(false)
    const [productName, setProductName] = useState("")
    const [sorter, setSorter] = useState(sorters[0])

    const toggleModal = () => {
        setModalOpen(!modalOpen)
    }

    const openModal = (p: IProduct) => {
        setSelectedProduct(p)
        setModalOpen(true)
    }

    return (
        <Fragment>
            <Header />
            {/* site key de reCAPTCHA v3, atada a marcosyclari.com. La secret key
                correspondiente vive en el .env del backend. */}
            <GoogleReCaptchaProvider reCaptchaKey="6LcxEIQtAAAAAOEH_cr2E2bNJDsRjFOzOUZ45WPJ">
                <div className='main-body'>
                    <div className='main-content'>
                        <div className='container filter-wrapper'>
                            <Filter categoryName={categoryName} sorter={sorter} filteredName={setProductName} sortBy={(s: Sorter) => {setSorter(s)}}/>
                        </div>
                        <div className="container products-wrapper">
                            {products
                                .filter(p =>
                                    (p.category.toString() === categoryParam || category === undefined) &&
                                    p.name.toLocaleLowerCase().includes(productName.toLocaleLowerCase())
                                )
                                .sort(sorter.sort)
                                .map((product, i) =>
                                    <Fragment key={product.name}>
                                        <div className="col-6 col-xs-6 col-sm-4 col-md-4 col-lg-3">
                                            <Product p={product} openModal={openModal} />
                                        </div>
                                    </Fragment>
                                )}
                        </div>
                        <div>
                            <SendGiftModal modalOpen={modalOpen} toggleModal={toggleModal} selectedProduct={selectedProduct} />
                        </div>
                    </div>
                </div>
            </GoogleReCaptchaProvider>
        </Fragment>

    )
}
